/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

export interface CloneRoomResponseDto {
  /** UUID of the created room */
  id: string;
  /**
   * Name of the created room
   * @nullable
   */
  name?: string | null;
}
